<script>
	import CBU from "../common/CBU.svelte"
	import {onMount} from 'svelte'
	import {USER} from '../store.js'

	export let cobranza
	export let formapago
	export let fd = { importe:0, nrocbu:'0', banco:'', titular:'', nrodocumento:'',observacion:'' }

	let banco = ''
	let cotizacion = 1.00

	$: lengthCBU =  (fd.nrocbu||'').split('').filter( v => '0123456789'.split('').indexOf(v)!==-1).length
	$: { fd.banco = banco }

	fd.importe = cobranza.importe

	$: {
		let CF = ((fd.importe-(fd.importe*formapago.coef1val)||0)).toFixed(2)
		fd.concepto = `DE${cobranza.idmoneda} ${cobranza.complejo} DEBDIR ${formapago.cuotas} x ${cotizacion!==1?'$':cobranza.simbolo} ${(fd.importe*formapago.coef1val/formapago.cuotas).toFixed(2)} ( CF : ${-1*CF} ${parseFloat(fd.importe)<cobranza.importe*cotizacion?'PARCIAL':''})`
	}

	function submit(){
		console.log(fd)
	}
/*
	onMount( async() => {
		fd.moneda=cobranza.idmoneda*1
		fd.simbolo = cobranza.simbolo+''

		if(formapago.cotizado!==1 && cobranza.idmoneda!==1 && formapago.cotizado!==cobranza.idmoneda){
			let rs = await fetch(`${API}/cotizacion/${formapago.cotizado}`)
			let ds = await rs.json()

			let query = `select cotizacion from monedas where idmoneda=${formapago.cotizado}`
			let data = await execQuery({query})
			cotizacion = data.data[0].cotizacion
			fd.moneda = 1
			fd.simbolo = '$'
			fd.conversion = cotizacion*1
		}
		fd.importe = (cobranza.importe*cotizacion).toFixed(2)
	})
*/
	onMount( async() => {
		fd.moneda=cobranza.idmoneda*1
		fd.simbolo = cobranza.simbolo+''

		if(formapago.cotizado!==1 && cobranza.idmoneda!==1 && formapago.cotizado!==cobranza.idmoneda){
			let rs = await fetch(`${API}/cotizacion/${formapago.cotizado}`)
			let ds = await rs.json()

			cotizacion = ds.data.Cotizacion
			fd.moneda = 1
			fd.simbolo = '$'
			fd.conversion = cotizacion*1
		}
		fd.importe = (cobranza.importe*cotizacion).toFixed(2)
	})


</script>

<form class="row" on:submit|preventDefault="{submit}">
		<div class="mt-2 col-auto">
			<label for="" class="mt3 ps2">Importe</label>
			<input class="form-control form-control-sm" tabindex="-1" bind:value={fd.importe} readonly={$USER.aclist==='cliente'}>
		</div>	
		<div class="mt-2 col-auto">
			<label for="" class="mt3 ps2">Cuotas</label>
			<input class="form-control form-control-sm" tabindex="-1" size="2" 
				min=1 max=12 bind:value={formapago.cuotas} 
				readonly={!formapago.chcuotas || $USER.aclist==='cliente'}>
		</div>	

		<div class="fs-5 mt-2 col-12">{fd.concepto}</div>

		<div class="mt-2 col-auto">
			<label for="" class="mt3 ps2">Numero CBU <small>{lengthCBU>0?` (${lengthCBU})`:''}</small></label>			
			<CBU class="form-control form-control-sm" placeholder="CBU" bind:value={fd.nrocbu}	bind:banco={banco}/>
		</div>
		<div class="mt-2 col-7">
			<label for="" class="mt3 ps2">Banco</label>
			<input class="form-control form-control-sm" placeholder="Banco" bind:value={fd.banco}>
		</div>
		<div class="col-12"></div>
		<div class="mt-2 col-auto">
			<label for="" class="mt3 ps2">Tit.Cta&nbsp;Bancaria</label>
			<input class="form-control form-control-sm" placeholder="Titular" bind:value={fd.titular}>
		</div>
		<div class="mt-2 col-auto">
			<label for="" class="mt3 ps2">Documento</label>
			<input class="form-control form-control-sm" placeholder="NroDocumento" bind:value={fd.nrodocumento}>
		</div>

		<div class="mt-2 col-12">
			<label for="" class="mt3 ps2">Observacion</label>
			<textarea placeholder="Observacion" style="height: 120px" class="form-control" bind:value={fd.observacion}></textarea>
		</div>
		
</form>

<style>
	label{ font-size: 0.8em;display: block; }
</style>